import { useMemo } from 'react';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { getConfigs } from 'reporting-data/report/multiConfigReportGetters';
import { isConfigReport, isMultiConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { useTableRowLimit } from './useTableRowLimit';
// @ts-expect-error Untyped dependency
import { setLimit } from 'reporting-action-components/lib/report-logic';
import { getLimit } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isImmutableJourneyReport } from 'reporting-snowflake/funnel/types/journeyReport';
export function useReportWithTableLimit({
  report,
  previewReport,
  onPreviewReportChange,
  defaultTableLimit
}) {
  const onChangeRowLimitCallback = value => {
    onPreviewReportChange(setLimit(value, report));
  };
  const tableLimit = useMemo(() => {
    if (!defaultTableLimit) {
      return;
    }
    if (isConfigReport(report) && !isMultiConfigReport(report)) {
      const reportLimit = getLimit(report);
      return reportLimit > defaultTableLimit ? reportLimit : defaultTableLimit;
    }
    return defaultTableLimit;
  }, [report, defaultTableLimit]);
  const {
    rowLimit,
    onRowLimitChange
  } = useTableRowLimit({
    onChangeRowLimitCallback,
    defaultRowLimit: tableLimit
  });
  if (!tableLimit) {
    return previewReport;
  }
  let reportWithTableLimit = previewReport;
  if (!isRelationalReport(report) && !isImmutableJourneyReport(report) && getReportChartType(previewReport) === TABLE) {
    reportWithTableLimit = setLimit(rowLimit, previewReport);
    if (isConfigReport(reportWithTableLimit) && !isMultiConfigReport(reportWithTableLimit)) {
      reportWithTableLimit = reportWithTableLimit.setIn(['displayParams', 'rowsPerPage', 'onChange'], onRowLimitChange);
    }
    if (isMultiConfigReport(reportWithTableLimit)) {
      const configs = getConfigs(reportWithTableLimit).map(config => config.set('limit', defaultTableLimit));
      reportWithTableLimit = reportWithTableLimit.set('reportConfigs', configs);
    }
  }
  return reportWithTableLimit;
}